import React, { Component } from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";

export class PortfolioDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      project: null,
      loading: true,
    };
  }

  componentDidMount() {
    this.loadPortfolioDetail();
  }

  loadPortfolioDetail = async () => {
    try {
      const slug = window.location.pathname.split("/").pop();

      const formData = new FormData();
      formData.append("portfolio_slug", slug);

      const response = await fetch(
        "https://idealtechnoride.in/api/portfoliodetail",
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await response.json();

      this.setState({
        project: data.length > 0 ? data[0] : null,
        loading: false,
      });
    } catch (error) {
      console.log(error);

      this.setState({
        loading: false,
      });
    }
  };

  render() {
    const { project, loading } = this.state;

    const seoData = project
      ? {
          seo_meta_title:
            project.portfolio_meta_title,
          seo_meta_description:
            project.portfolio_meta_description,
          seo_meta_keywords:
            project.portfolio_meta_keywords,
          seo_canonical_url:
            project.portfolio_canonical_url,
          seo_og_title:
            project.portfolio_og_title,
          seo_og_description:
            project.portfolio_og_description,
          seo_robots:
            project.portfolio_robots,
        }
      : null;

    if (loading) {
      return (
        <div className="container py-5 text-center">
          <h3>Loading...</h3>
        </div>
      );
    }

    if (!project) {
      return (
        <div className="container py-5 text-center">
          <h2>Project Not Found</h2>
        </div>
      );
    }

    return (
      <>
        <SEO seo={seoData} />

        {/* Hero Start */}
        <div className="container-fluid pb-5 hero-header mb-5">
          <div className="container py-5">
            <div className="row g-3 align-items-center">

              <div className="col-lg-6 text-center text-lg-start">
                <h1 className="display-3 mb-0 animated slideInLeft">
                  {project.portfolio_title}
                </h1>

                <p className="text-muted mt-2">
                  {project.portfolio_category}
                </p>
              </div>

              <div className="col-lg-6 animated slideInRight">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb justify-content-center justify-content-lg-end mb-0">
                    <li className="breadcrumb-item">
                      <Link
                        className="text-secondary"
                        to="/"
                      >
                        Home
                      </Link>
                    </li>

                    <li className="breadcrumb-item">
                      <Link
                        className="text-secondary"
                        to="/portfolio"
                      >
                        Portfolio
                      </Link>
                    </li>

                    <li
                      className="breadcrumb-item active"
                      aria-current="page"
                    >
                      {project.portfolio_title}
                    </li>
                  </ol>
                </nav>
              </div>

            </div>
          </div>
        </div>
        {/* Hero End */}

        {/* Content Start */}
        <div className="container py-5">

          {project.portfolio_banner_image && (
            <img
              src={project.portfolio_banner_image}
              alt={project.portfolio_title}
              className="img-fluid rounded mb-5 w-100"
            />
          )}

          <div className="row">

            <div className="col-lg-8">

              {/* Overview */}
              <h3 className="mb-3">
                Project Overview
              </h3>

              <p className="mb-5">
                {project.portfolio_overview}
              </p>

              {/* Challenge */}
              <h3 className="mb-3">
                Challenge
              </h3>

              <p className="mb-5">
                {project.portfolio_challenge}
              </p>

              {/* Solution */}
              <h3 className="mb-3">
                Solution
              </h3>

              <p className="mb-5">
                {project.portfolio_solution}
              </p>

              {/* Technologies */}
              <h3 className="mb-3">
                Technologies Used
              </h3>

              <div className="mb-5 d-flex flex-wrap gap-2">
                {project.portfolio_technologies &&
                  project.portfolio_technologies
                    .split(",")
                    .map((tech, index) => (
                      <span
                        key={index}
                        className="badge bg-secondary p-2"
                      >
                        {tech.trim()}
                      </span>
                    ))}
              </div>

              {/* Features */}
              <h3 className="mb-3">
                Key Features
              </h3>

              <ul className="mb-5">
                {project.portfolio_features &&
                  project.portfolio_features
                    .split(",")
                    .map((feature, index) => (
                      <li key={index}>
                        {feature.trim()}
                      </li>
                    ))}
              </ul>

              {/* Results */}
              <h3 className="mb-3">
                Results
              </h3>

              <p className="mb-5">
                {project.portfolio_results}
              </p>

              {/* Conclusion */}
              <h3 className="mb-3">
                Conclusion
              </h3>

              <p className="mb-5">
                {project.portfolio_conclusion}
              </p>

              <Link
                to="/portfolio"
                className="btn btn-primary"
              >
                Back To Portfolio
              </Link>

            </div>

            {/* Sidebar */}
            <div className="col-lg-4">

              <div className="bg-light p-4 rounded">

                <h4 className="mb-4">
                  Project Information
                </h4>

                <div className="mb-3">
                  <strong>Project:</strong>
                  <br />
                  {project.portfolio_title}
                </div>

                <div className="mb-3">
                  <strong>Client:</strong>
                  <br />
                  {project.portfolio_client_name}
                </div>

                <div className="mb-3">
                  <strong>Duration:</strong>
                  <br />
                  {project.portfolio_duration}
                </div>

                <div className="mb-3">
                  <strong>Category:</strong>
                  <br />
                  {project.portfolio_category}
                </div>

              </div>

            </div>

          </div>

        </div>
        {/* Content End */}
      </>
    );
  }
}

export default PortfolioDetail;